import React from 'react';
import { EventContentArg } from '@fullcalendar/react';
import { CalendarViewTypes } from '@uplift/types';
import { EventItem } from './EventItem.component';


export type EventItemCreatedProps = EventContentArg;


export const EventItemCreated: React.FC<EventItemCreatedProps> = (props) => {
  const timezone = props.view.getOption('timeZone') as string;
  const isSignupIncomplete = !props.event.extendedProps.isRegular;
  const isDayView = props.view.type === CalendarViewTypes.timeGridDay;

  const eventVariant = React.useMemo(() => {
    if (props.event.extendedProps.isICSConflict) {
      return 'appointmentOverlapWarning';
    }

    if (isSignupIncomplete) {
      return 'appointmentWarning';
    }

    return 'appointment';
  }, [ isSignupIncomplete, props.event.extendedProps.isICSConflict ]);

  if (props.event.start === null || props.event.end === null) {
    return null;
  }

  return (
    <EventItem
      id={props.event.id}
      title={props.event.title}
      startTime={props.event.start}
      endTime={props.event.end}
      isEnd={props.isEnd}
      isStart={props.isStart}
      timezone={timezone}
      isDayView={isDayView}
      variant={eventVariant}
      leftSpacing={props.event.extendedProps.inOnAvailability}
    />
  );
};
